export default {
  validatePhoneNumber(phoneNumber) {
    const cleanedNumber = phoneNumber.replace(/[\s-]/g, '');
    return (/^\d{11}$/.test(cleanedNumber) || /^(\d{3})-(\d{4})-(\d{4})$/.test(this.phoneNumber));

  }
}



// WEBPACK FOOTER //
// ./src/helper/validationHelper.js